export class ReceiptDiscrepancy{

    
        sequenceNumber: number;
        notes: string;
        reason: string;
        actualQuantityReceived:number;
    
}